import { render, staticRenderFns } from "./Basisdaten.vue?vue&type=template&id=1e00c5df&scoped=true"
import script from "./Basisdaten.vue?vue&type=script&lang=js"
export * from "./Basisdaten.vue?vue&type=script&lang=js"
import style0 from "./Basisdaten.vue?vue&type=style&index=0&id=1e00c5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e00c5df",
  null
  
)

export default component.exports